import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import CSFInitialize from 'components/CreatorStoreFront/CSFInitialize';

const CreatorStoreFront = () => <CSFInitialize />;

export default wrapFunctionalComponent(CreatorStoreFront, 'CreatorStoreFront');
